import * as React from 'react';

export default function useDebouncedValue(
  value: boolean,
  delay: number,
): boolean {
  const [debouncedValue, setDebouncedValue] = React.useState(value);
  const timeoutRef = React.useRef<ReturnType<typeof setTimeout> | null>(null);

  React.useEffect(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }

    if (value) {
      timeoutRef.current = setTimeout(() => {
        setDebouncedValue(true);
      }, delay);
    } else {
      setDebouncedValue(false);
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [value, delay]);

  return debouncedValue;
}
